export const primaryAccentColor = '#F27B50'; // color of primary button, secondary button border etc
